"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LandingPage = void 0;
var _mui = require("@ori-ui/mui");
var _editorialComponents = require("@ori/editorial-components");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _LandingPageSkeleton = require("../LandingPageSkeleton");
var _constants = require("./constants");
var _landingPageClasses = require("./landingPageClasses");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component that renders content on editorial landing page.
 */ const LandingPage = (param)=>{
    let { breadcrumbs, data, articlesProps, categoriesProps, className } = param;
    const theme = (0, _mui.useTheme)();
    const { translations, formatMessage } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    var _data_application;
    const { editorialLandingPage } = (_data_application = data === null || data === void 0 ? void 0 : data.application) !== null && _data_application !== void 0 ? _data_application : {};
    const { mode = 'featured', title: articlesTitle = translations.inspirationCorner } = articlesProps !== null && articlesProps !== void 0 ? articlesProps : {};
    const { title: categoriesTitle = translations.categories } = categoriesProps !== null && categoriesProps !== void 0 ? categoriesProps : {};
    const getPaginationInfoText = (0, _react.useCallback)((value, max)=>formatMessage('showingXOutOfYProducts', {
            value,
            max
        }), [
        formatMessage
    ]);
    if (!editorialLandingPage) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LandingPageSkeleton.LandingPageSkeleton, {
            className: className,
            articlesMode: mode
        });
    }
    const { themeTag, description, editorialItems, imageUrl, backgroundStorybookColor, themeItems } = editorialLandingPage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.LANDING_PAGE),
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.TopBanner, {
                breadcrumbs: breadcrumbs,
                imageUrl: imageUrl,
                backgroundColor: (0, _presentationUtils.mapBackendColorToTheme)({
                    theme,
                    backendColor: backgroundStorybookColor,
                    fallBackColor: theme.palette.common.white
                }),
                textColor: theme.palette.text.primary,
                title: themeTag,
                className: _landingPageClasses.landingPageClasses.topBanner
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Description, {
                description: description,
                className: _landingPageClasses.landingPageClasses.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.CategoriesSection, {
                categories: themeItems,
                title: categoriesTitle,
                viewButtonText: translations.view,
                className: _landingPageClasses.landingPageClasses.categoriesSection
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.ArticlesSection, {
                articles: editorialItems,
                countOfArticles: editorialItems === null || editorialItems === void 0 ? void 0 : editorialItems.length,
                labelRead: translations.readNow,
                mode: mode,
                loadMoreButtonText: translations.loadMore,
                title: articlesTitle,
                className: _landingPageClasses.landingPageClasses.articlesSection,
                getPaginationInfoText: getPaginationInfoText
            })
        ]
    });
};
exports.LandingPage = LandingPage;
